
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF"}},[_c('rect',{attrs:{"width":"21","height":"2","rx":"1"}}),_c('rect',{attrs:{"width":"21","height":"2","y":"7","rx":"1"}}),_c('path',{attrs:{"d":"M1 14h19a1 1 0 010 2H1a1 1 0 010-2z"}})])])
          )
        }
      }
    